<template>
  <LoadingWrapper :loading-bool="loading">
    <div class="row">
      <div class="col-md-3 mt-2">
        <a :href="resolve('site.list')"
           class="btn btn-primary"
           @click="navigate('site.list', $event)">
          Dashboard
        </a>
      </div>
      <div v-if="evaluations.length > 1" class="offset-md-3 col-md-3 mt-2 mb-0">
        <b-form-select
          v-model="currentEvaluation"
          :options="evaluations"
          @change="selectEvaluation"
        />
      </div>
      <div class="col-md-3 mt-2" :class="{'offset-md-6': evaluations.length === 1}">
        <b-nav-item-dropdown type="dark" right text="Download" class="btn btn-primary download-dropdown">
          <b-dropdown-item :href="downloadSummaryPDFURL" target="_blank">
            Summary PDF
          </b-dropdown-item>
          <b-dropdown-item v-b-tooltip.bottom
                           :href="downloadDetailedPDFURL"
                           target="_blank">
            Detailed PDF
          </b-dropdown-item>
          <b-dropdown-item v-b-tooltip.bottom
                           :href="downloadDetailedPowerpointURL"
                           :disabled="!canPowerpoint"
                           :title="canPowerpoint ? '' : 'Watch this space!\n\n  Detailed PowerPoints including screenshots are coming soon.'"
                           target="_blank">
            Detailed PowerPoint
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </div>
    </div>
  </LoadingWrapper>
</template>

<style lang="scss" scoped>
  @import "../../../assets/scss/variables";

  a {
    width: 100%;
    @media (max-width: 767px) {
      margin-top: .5em;
    }
  }

  .download-dropdown {
    width: 100%;
    margin: 0;
    padding: 0.4em 0 0;
    background-color: rgba($purple, 0.9);
    border-color: $purple;
    min-height: 2.5em;

    ::v-deep .nav-link {
      height: 100%;
      width: 100%;
      line-height: 1.5;
      padding: 0;
    }

    ::v-deep span, & ::after {
      color: white;
    }
  }
</style>

<script>
  import apiMixin from "../../../utils/api"
  import datesMixin from "../../../utils/dates"
  import LoadingWrapper from "../../navigation/LoadingWrapper"
  import {features} from "../../../utils/constants"

  export default {
    name: 'EvaluationSubcomponentsSelector',
    components: {LoadingWrapper},
    mixins: [apiMixin, datesMixin],
    props: {
      siteId: {type: Number, required: true},
      evaluationId: {type: Number, required: true},
    },
    data() {
      return {
        evaluations: [],
        currentEvaluation: this.evaluationId,
        downloadSummaryPDFURL: null,
        downloadDetailedPDFURL: null,
        downloadDetailedPowerpointURL: null,
      }
    },
    computed: {
      canPowerpoint() {
        return this.$store.getters['user/featureFlags'].includes(features.powerpoint)
      },
    },
    methods: {
      load() {
        const pdfRoot = `${process.env.VUE_APP_API_BASE}/api/sites/${this.siteId}/` +
          `evaluations/${this.evaluationId}`
        this.downloadSummaryPDFURL = `${pdfRoot}/report.pdf`
        this.downloadDetailedPDFURL = `${pdfRoot}/detailed-report.pdf`
        this.downloadDetailedPowerpointURL = `${pdfRoot}/detailed-report.pptx`
        this.withLoading(async () => {
          let response = await this.get(`/api/sites/${this.siteId}/evaluations/completed/`)
          this.evaluations = response.items.map(item => {
            return {value: item.id, text: this.renderDate(item.completed_at)}
          })
        })
      },
      selectEvaluation(evaluationId) {
        this.$router.push({
          name: 'evaluation.detail', params: {
            siteId: this.siteId,
            evaluationId: evaluationId
          }
        })
      }
    }
  }
</script>